<template>
  <div>
    <div v-if="typeAction === locationConstants.UPDATE_LOCAL_POST">
      <v-row>
        <v-spacer />

        <v-col>
          <v-card>
            <v-tabs
                show-arrows
                v-model="tab"
                class="mb-4"
            >
              <v-tab v-for="tab in tabs" v-bind:key="tab.id">
                <v-icon class="mr-2">{{ tab.icon }}</v-icon>
                {{ tab.title }}
              </v-tab>
            </v-tabs>
          </v-card>

          <v-progress-linear v-if="loading" indeterminate class="py-0 my-0"/>
        </v-col>

        <v-spacer />
      </v-row>

      <div id="scroll-target"></div>

      <v-tabs-items v-model="tab" class="pt-2 px-1">
        <location-post
            v-for="post in get(posts, 'data', [])"
            v-bind:key="post.id"
            :id="post.id"
            :title="get(post, 'event_title', '')"
            :summary="get(post, 'summary', '')"
            :type="get(post, 'topic_type', '')"
            :action-button-link="get(post, 'action_url', '')"
            :action-button-type="get(post, 'action_type', '')"
            :created-at="get(post, 'create_time_formatted', '')"
            :alert-type="get(post, 'alert_type', '')"
            :event-schedule="get(post, 'event_schedule_formatted', '')"
            :event-schedule-code="get(post, 'event_schedule_code_formatted', '')"
            :offer-coupon-code="get(post, 'offer_coupon_code', '')"
            :offer-redeem-online-url="get(post, 'offer_redeem_online_url', '')"
            :offer-terms-and-conditions="get(post, 'offer_terms_conditions', '')"
            :location-name="get(post, 'location_name', '')"
            :location-phone="get(post, 'location.primary_phone', '')"
            :on-updated="fetchPosts"
            :on-bulk-updated="onBulkUpdated"
            :on-bulk-deleted="onBulkDeleted"
            :open-date="parseDate(get(post, 'event_start_date', ''))"
            :open-time="parseTime(get(post, 'event_start_date', ''))"
            :close-date="parseDate(get(post, 'event_end_date', ''))"
            :close-time="parseTime(get(post, 'event_end_date', ''))"
            :background="getBackground(get(post, 'media[0].sourceUrl', ''))"
            :media="get(post, 'media[0].sourceUrl', '')"
            :media-format="get(post, 'media[0].mediaFormat', '')"
            :bulk-update="true"
            :bulk-params="{ ids, account, allSelected, total, filters }"
        />
      </v-tabs-items>

      <v-row class="pa-4">
        <v-spacer/>

        <v-btn
          :disabled="page === 1"
          icon
          elevation="2"
          class="mr-1"
          @click="previousPage"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-btn
          :disabled="Array.isArray(posts.data) && posts.data.length < limit"
          icon
          elevation="2"
          class="ml-1"
          @click="nextPage"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-spacer/>
      </v-row>
    </div>

    <v-row v-else no-gutters>
      <v-spacer />

      <v-col>
        <v-card width="600">
          <location-post-form
              :location-name="''"
              :location-phone="''"
              :prop-type="type"
              :bulk-params="{ ids, account, allSelected, total, filters }"
              :bulk-create="true"
              :on-bulk-updated="onBulkUpdated"
          />
        </v-card>
      </v-col>

      <v-spacer />
    </v-row>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import LocationPost from '@/views/Locations/Components/LocationPost'
import LocationPostForm from '@/views/Locations/Modals/LocationPostForm'
import * as postsConstants from '@/constants/posts'
import * as locationConstants from '@/constants/locations';
import {mapState} from 'vuex'
import {get} from 'lodash'
import {handleResponseError} from '@/api/handleError'
import backgroundVideoDefault from '@/assets/video-logodefault.png'

export default {
  name: 'LocationPostsBulkTab',
  components: {
    LocationPost,
    LocationPostForm
  },
  computed: {
    ...mapState({
      posts: state => state.posts.allBulk,
      postUpdateBulk: state => state.posts.postUpdateBulk,
      postDeleteBulk: state => state.posts.postDeleteBulk,
    }),
    get: function() {
      return get
    },
    locationConstants() {
      return locationConstants
    }
  },
  props: {
    ids: {
      required: true,
      type: Array
    },
    account: {
      required: true,
      type: String
    },
    allSelected: {
      required: true,
      type: Boolean
    },
    total: Number,
    typeAction: String,
    filters: Object,
  },
  watch: {
    tab: function(newTab) {
      if (newTab === 0) this.type = null
      if (newTab === 1) this.type = postsConstants.ALERT_TYPE
      if (newTab === 2) this.type = postsConstants.OFFER_TYPE
      if (newTab === 3) this.type = postsConstants.STANDARD_TYPE
      if (newTab === 4) this.type = postsConstants.EVENT_TYPE
      this.page = 1
      this.fetchPosts()
    },
    page: function() {
      this.fetchPosts()
      this.$vuetify.goTo('#scroll-target')
    }
  },
  data: () => ({
    loading: false,
    location_name: '',
    type: null,
    tab: null,
    tabs: [
      { id: null, title: 'Todas' },
      { id: 2, title: 'Alertas' },
      { id: 3, title: 'Ofertas' },
      { id: 4, title: 'Novidades' },
      { id: 5, title: 'Eventos' },
    ],
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    limit: 15,
    page: 1,
  }),
  methods: {
    nextPage() {
      this.page = this.page + 1
    },
    previousPage() {
      this.page = this.page - 1 > 0 ? this.page - 1 : 1
    },
    onBulkUpdated(data) {
      const taskId = get(data || this.postUpdateBulk, 'tasks[0].id')
      this.$store.dispatch('posts/clearBulk')
      this.$router.push(`/task/${taskId}`)
    },
    onBulkDeleted(data) {
      const taskId = get(data || this.postDeleteBulk, 'tasks[0].id')
      this.$store.dispatch('posts/clearBulk')
      this.$router.push(`/task/${taskId}`)
    },
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    fetchPosts: async function() {
      this.loading = true
      await this.$store.dispatch('posts/getPostsBulk', {
        params: this.$props,
        limit: this.limit,
        page: this.page,
        topic_type: this.type,
        sort: 'create_time',
        desc: true,
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as publicações.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      })
      this.loading = false
    },
    parseDate(date) {
      if (typeof date !== 'string') return ''
      return date.split(' ')[0]
    },
    parseTime(time) {
      if (typeof time !== 'string') return ''
      return time.split(' ')[1]
    },
    getBackground: function(media) {
      let contains = media.includes('mp4')
      if(contains)
        return backgroundVideoDefault

      return media
    },
  }
}
</script>

<style scoped>

</style>